<template>
  <b-form @submit.prevent="handleSubmit">
    <b-row>
      <b-col cols="6">
        <basic-input
          :value.sync="form.name"
          name="name"
          label="Tên dịch vụ"
          placeholder="VD: Tư vấn dinh dưỡng"
          validate="required"
          v-validate="'required'"
          data-vv-as="Tên dịch vụ"
        />
        <span class="text-danger">{{ errors.first('name') }}</span>
      </b-col>

      <b-col v-if="false" cols="6">
        <basic-select
          label="Danh mục"
          :value.sync="form.category"
          name="category"
          placeholder="Chọn danh mục"
          :options="categoryOptions"
          track-by="value"
          value-label="text"
          :required="true"
          validate="required"
          v-validate="'required'"
          data-vv-as="Danh mục"
          @input="($event) => selected($event, 'category', categoryOptions)"
        />
        <span class="text-danger">{{ errors.first('category') }}</span>
      </b-col>

      <b-col cols="6">
        <basic-input
          :value.sync="form.price"
          name="price"
          label="Giá (VNĐ)"
          placeholder="VD: 500000"
          type="number"
          data-vv-as="Giá"
        />
      </b-col>

      <b-col cols="6">
        <basic-input
          :value.sync="form.minutes"
          name="minutes"
          label="Thời gian (phút)"
          placeholder="VD: 60"
          type="number"
          data-vv-as="Thời gian"
        />
      </b-col>

      <b-col cols="6">
        <basic-select
          label="Trạng thái"
          :value.sync="selectedStatusObj"
          name="status"
          placeholder="Chọn trạng thái"
          :options="statusOptions"
          track-by="value"
          value-label="text"
          @input="onStatusSelect"
        />
      </b-col>

      <b-col cols="12">
        <label>Nhà cung cấp dịch vụ</label>
        <div ref="providerDropdownContainer" class="position-relative">
          <input
            v-model="providerSearchText"
            type="text"
            class="form-control"
            placeholder="Tìm kiếm nhà cung cấp..."
            @input="onProviderSearch"
            @focus="showProviderDropdown = true"
          />
          <div
            v-if="showProviderDropdown"
            class="dropdown-menu show position-absolute w-100 provider-dropdown"
            style="top: 100%; left: 0; z-index: 1000; max-height: 320px; overflow-y: auto;"
          >
            <div v-if="filteredProviders.length > 0">
              <a
                v-for="provider in filteredProviders"
                :key="provider.value"
                href="#"
                class="dropdown-item"
                @click.prevent="selectProvider(provider)"
              >
                {{ provider.text }}
              </a>
            </div>
            <div v-if="providerSearchText && filteredProviders.length === 0">
              <div class="dropdown-divider"></div>
              <a
                href="#"
                class="dropdown-item text-success font-weight-bold"
                @click.prevent="openAddProviderModal"
              >
                <i class="ki ki-plus"></i> Thêm nhà cung cấp: "{{ providerSearchText }}"
              </a>
            </div>
            <div v-if="!providerSearchText && providerOptions.length === 0" class="dropdown-item text-muted">
              Không có dữ liệu
            </div>
          </div>
        </div>
      </b-col>

      <b-col cols="6">
        <basic-select
          label="Tính năng app"
          :value.sync="selectedAppFeatureObj"
          name="appFeature"
          placeholder="Chọn tính năng"
          :options="appFeatureOptions"
          track-by="value"
          value-label="text"
          @input="onAppFeatureSelect"
        />
      </b-col>

      <b-col cols="6">
        <label>Tag</label>
        <div ref="tagDropdownContainer" class="position-relative">
          <input
            v-model="tagSearchText"
            type="text"
            class="form-control"
            placeholder="Tìm hoặc tạo tag..."
            @input="onTagSearch"
            @focus="showTagDropdown = true"
          />
          <div
            v-if="showTagDropdown"
            class="dropdown-menu show position-absolute w-100 provider-dropdown"
            style="top: 100%; left: 0; z-index: 1000; max-height: 240px; overflow-y: auto;"
          >
            <div v-if="filteredTags.length > 0">
              <a
                v-for="tag in filteredTags"
                :key="tag.value"
                href="#"
                class="dropdown-item"
                @click.prevent="selectTag(tag)"
              >
                {{ tag.text }}
              </a>
            </div>
            <div v-if="tagSearchText && filteredTags.length === 0">
              <div class="dropdown-divider"></div>
              <a
                href="#"
                class="dropdown-item text-success font-weight-bold"
                @click.prevent="createNewTag"
              >
                <i class="ki ki-plus"></i> Tạo tag mới: "{{ tagSearchText }}"
              </a>
            </div>
            <div v-if="!tagSearchText && tagOptions.length === 0" class="dropdown-item text-muted">
              Không có dữ liệu
            </div>
          </div>
        </div>
      </b-col>

      <!-- appFeature=1 (Online) / appFeature=2 (Offline): Chuyên khoa + Phòng khám -->
      <template v-if="[1, 2].includes(form.appFeature)">
        <b-col cols="6" class="mt-3">
          <basic-select
            label="Chuyên khoa"
            :value.sync="selectedSpecialtyObj"
            name="specialtyId"
            placeholder="Chọn chuyên khoa..."
            :options="specialtyOptions"
            track-by="value"
            value-label="text"
            @input="onSpecialtySelect"
          />
        </b-col>
        <b-col cols="6" class="mt-3">
          <basic-select
            label="Phòng khám"
            :value.sync="selectedClinicObj"
            name="clinicId"
            placeholder="Chọn phòng khám..."
            :options="clinicOptions"
            track-by="value"
            value-label="text"
            @input="onClinicSelect"
          />
          <small v-if="loadingClinic" class="text-muted">Đang tải danh sách phòng khám...</small>
        </b-col>
      </template>

      <!-- appFeature=3: Ưu đãi -->
      <b-col v-if="form.appFeature === 3" cols="12" class="mt-3">
        <basic-select
          label="Ưu đãi"
          :value.sync="selectedBenefitTypeObj"
          name="benefitTypeId"
          placeholder="Chọn ưu đãi..."
          :options="benefitTypeOptions"
          track-by="value"
          value-label="text"
          @input="onBenefitTypeSelect"
        />
      </b-col>

      <!-- appFeature=4: Báo cáo — loại hồ sơ sức khoẻ -->
      <b-col v-if="form.appFeature === 4" cols="6" class="mt-3">
        <basic-select
          label="Hồ sơ sức khoẻ"
          name="reportType"
          :value.sync="selectedReportTypeObj"
          :options="reportTypeOptions"
          track-by="value"
          value-label="text"
          placeholder="Chọn loại hồ sơ..."
          @input="onReportTypeSelect"
        />
      </b-col>

      <b-col cols="12" class="mt-3">
        <basic-text-area
          :value.sync="form.description"
          name="description"
          label="Mô tả"
          placeholder="Nhập mô tả chi tiết về dịch vụ..."
          :rows="4"
        />
      </b-col>
    </b-row>

    <!-- Modal thêm nhà cung cấp mới -->
    <b-modal v-model="showAddProviderModal" title="Thêm nhà cung cấp mới" centered no-close-on-backdrop>
      <b-form>
        <b-form-group label="Tên nhà cung cấp" label-for="newProviderName">
          <b-form-input
            id="newProviderName"
            v-model="newProviderData.name"
            placeholder="Nhập tên nhà cung cấp..."
            required
          ></b-form-input>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" @click="cancelAddProvider">Hủy</b-button>
        <b-button variant="success" :disabled="isCreatingProvider" @click="createNewProvider">
          <span v-if="isCreatingProvider">Đang thêm...</span>
          <span v-else>Thêm mới</span>
        </b-button>
      </template>
    </b-modal>
  </b-form>
</template>

<script>
import axios from 'axios';
import { SERVICE_CATEGORY_OPTIONS, APP_FEATURE_OPTIONS } from '../../constants/clinicBundleConstants';

export default {
  name: 'ServiceForm',
  props: {
    value: {
      type: Object,
      default: () => ({
        id: null,
        name: '',
        category: null,
        price: null,
        minutes: null,
        serviceProviderId: null,
        description: '',
        status: 0,
        appFeature: 0,
        reportType: null,
        bundleTagId: null,
        specialtyId: null,
        specialtyName: null,
        clinicId: null,
        benefitTypeId: null,
      }),
    },
  },
  data() {
    return {
      form: { ...this.value },
      categoryOptions: SERVICE_CATEGORY_OPTIONS,
      selectedStatusObj: null,
      statusOptions: [
        { value: 0, text: 'Hoạt động' },
        { value: 1, text: 'Không hoạt động' },
      ],
      reportTypeOptions: [
        { value: 1, text: 'Xét nghiệm' },
        { value: 2, text: 'Chẩn đoán hình ảnh' },
        { value: 3, text: 'Thăm dò chức năng' },
        { value: 4, text: 'Nội soi và sinh thiết' },
        { value: 5, text: 'Kết quả khám' },
      ],
      selectedReportTypeObj: null,
      appFeatureOptions: APP_FEATURE_OPTIONS,
      providerOptions: [],
      selectedProviderObj: null,
      providerSearchText: '',
      showProviderDropdown: false,
      filteredProviders: [],
      showAddProviderModal: false,
      isCreatingProvider: false,
      newProviderData: { name: '' },
      userEditing: false,
      restoringForm: false,
      selectedAppFeatureObj: null,
      tagOptions: [],
      tagSearchText: '',
      showTagDropdown: false,
      filteredTags: [],
      // Đặt lịch
      specialtyOptions: [],
      selectedSpecialtyObj: null,
      clinicOptions: [],
      selectedClinicObj: null,
      loadingClinic: false,
      // Ưu đãi
      benefitTypeOptions: [],
      selectedBenefitTypeObj: null,
    };
  },

  created() {
    this.loadProviders();
    this.loadTags();
    if ([1, 2].includes(this.form.appFeature)) {
      this._restoreSpecialtyClinic(this.form.specialtyId, this.form.clinicId);
    }
    if (this.form.appFeature === 3) {
      this.loadBenefitTypes().then(() => {
        this.selectedBenefitTypeObj = this.benefitTypeOptions.find((o) => o.value === this.form.benefitTypeId) || null;
      });
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  watch: {
    value: {
      async handler(newVal) {
        if (this.userEditing) return;
        if (JSON.stringify(newVal) === JSON.stringify(this.form)) return;

        this.restoringForm = true;
        const prevProviderId = this.form.serviceProviderId;
        const prevTagId = this.form.bundleTagId;
        this.form = { ...newVal };
        this.selectedStatusObj = this.statusOptions.find((o) => o.value === newVal.status) || null;
        this.selectedAppFeatureObj = this.appFeatureOptions.find((o) => o.value === newVal.appFeature) || null;
        this.selectedReportTypeObj = this.reportTypeOptions.find((o) => o.value === newVal.reportType) || null;

        if (newVal.serviceProviderId !== prevProviderId) {
          const found = this.providerOptions.find((p) => p.value === newVal.serviceProviderId) || null;
          this.selectedProviderObj = found;
          this.providerSearchText = found ? found.text : '';
        }

        if (newVal.bundleTagId !== prevTagId) {
          const found = this.tagOptions.find((t) => t.value === newVal.bundleTagId) || null;
          this.tagSearchText = found ? found.text : '';
        }

        if ([1, 2].includes(newVal.appFeature)) {
          await this._restoreSpecialtyClinic(newVal.specialtyId, newVal.clinicId);
        }

        if (newVal.appFeature === 3) {
          await this.loadBenefitTypes();
          this.selectedBenefitTypeObj = this.benefitTypeOptions.find((o) => o.value === newVal.benefitTypeId) || null;
        } else {
          this.selectedBenefitTypeObj = null;
        }

        this.$nextTick(() => { this.restoringForm = false; });
      },
      deep: true,
      immediate: true,
    },
    form: {
      handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true,
    },
    providerOptions(options) {
      if (this.form.serviceProviderId) {
        const found = options.find((p) => p.value === this.form.serviceProviderId) || null;
        this.selectedProviderObj = found;
        this.providerSearchText = found ? found.text : '';
      }
      this.onProviderSearch();
    },
    tagOptions(options) {
      if (this.form.bundleTagId) {
        const found = options.find((t) => t.value === this.form.bundleTagId) || null;
        this.tagSearchText = found ? found.text : '';
      }
      this.onTagSearch();
    },
    'form.appFeature'(val) {
      this.selectedAppFeatureObj = this.appFeatureOptions.find((o) => o.value === val) || null;
      if (val !== 4) {
        this.form.reportType = null;
        this.selectedReportTypeObj = null;
      }
      if ([1, 2].includes(val)) {
        this.loadSpecialties();
        // Đổi qua lại Online/Offline (do user chọn, không phải lúc restore data cũ):
        // bộ clinic_ids hợp lệ khác nhau (telemedicine vs thường) -> reset clinic đã chọn, tải lại theo chuyên khoa hiện tại
        if (!this.restoringForm) {
          this.form.clinicId = null;
          this.selectedClinicObj = null;
          this.clinicOptions = [];
          const clinicIds = this._getClinicIdsForSpecialty(this.selectedSpecialtyObj);
          if (clinicIds.length > 0) {
            this.fetchClinics(clinicIds);
          }
        }
      } else {
        this.form.specialtyId = null;
        this.form.specialtyName = null;
        this.form.clinicId = null;
        this.selectedSpecialtyObj = null;
        this.selectedClinicObj = null;
        this.clinicOptions = [];
      }
      if (val === 3) {
        this.loadBenefitTypes();
      } else {
        this.benefitTypeOptions = [];
        this.selectedBenefitTypeObj = null;
        this.form.benefitTypeId = null;
      }
    },
  },

  methods: {
    async loadProviders() {
      try {
        const { data } = await this.$api.get('/ServiceProvider/All');
        this.providerOptions = (data || []).map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (e) {
        console.error('Không thể tải danh sách nhà cung cấp:', e);
      }
    },

    // AppFeature=1 (Khám từ xa/Online) dùng telemedicine_clinic_ids, AppFeature=2 (Đặt lịch/Offline) dùng clinic_ids
    _getClinicIdsForSpecialty(specialtyObj) {
      if (!specialtyObj) return [];
      return this.form.appFeature === 1
        ? specialtyObj.telemedicineClinicIds || []
        : specialtyObj.clinicIds || [];
    },

    async _restoreSpecialtyClinic(specialtyId, clinicId) {
      const sid = specialtyId != null ? Number(specialtyId) : null;
      const cid = clinicId != null ? Number(clinicId) : null;
      const hasSpecialty = sid != null && !isNaN(sid) && sid > 0;
      const hasClinic = cid != null && !isNaN(cid) && cid > 0;

      await this.loadSpecialties();

      if (hasSpecialty) {
        this.selectedSpecialtyObj = this.specialtyOptions.find((o) => Number(o.value) === sid) || null;
        if (!this.selectedSpecialtyObj && this.form.specialtyName) {
          this.selectedSpecialtyObj = { value: sid, text: this.form.specialtyName, clinicIds: [], telemedicineClinicIds: [] };
        }
        const specialtyClinicIds = this._getClinicIdsForSpecialty(this.selectedSpecialtyObj);
        const clinicIds = specialtyClinicIds.length
          ? specialtyClinicIds
          : hasClinic ? [cid] : [];
        if (clinicIds.length > 0) {
          await this.fetchClinics(clinicIds);
          if (hasClinic) {
            this.selectedClinicObj = this.clinicOptions.find((o) => Number(o.value) === cid) || null;
          }
        }
      } else if (hasClinic) {
        await this.fetchClinics([cid]);
        this.selectedClinicObj = this.clinicOptions.find((o) => Number(o.value) === cid) || null;
      }
    },

    async loadSpecialties() {
      if (this.specialtyOptions.length > 0) return;
      try {
        const { data } = await axios.get('https://api.staging.docosan.com/api/diseases-configuration-diab?language=vi');
        const list = Array.isArray(data)
          ? data
          : data?.data || data?.items || data?.diseases || data?.specialties || data?.result || [];
        this.specialtyOptions = list.map((item) => ({
          value: item.id,
          text: item.name,
          clinicIds: item.clinic_ids || [],
          telemedicineClinicIds: item.telemedicine_clinic_ids || [],
        }));
      } catch (e) {
        console.error('[ServiceForm] Không thể tải danh sách chuyên khoa:', e);
      }
    },

    async onSpecialtySelect(val) {
      const found = this.specialtyOptions.find((o) => o.value === val) || null;
      this.selectedSpecialtyObj = found;
      this.selectedClinicObj = null;
      this.clinicOptions = [];
      this.form = { ...this.form, specialtyId: found ? found.value : null, specialtyName: found ? found.text : null, clinicId: null };
      const clinicIds = this._getClinicIdsForSpecialty(found);
      if (clinicIds.length > 0) {
        await this.fetchClinics(clinicIds);
      }
    },

    async fetchClinics(clinicIds) {
      if (!clinicIds || clinicIds.length === 0) return;
      this.loadingClinic = true;
      try {
        const { data } = await axios.post(
          'https://api.staging.docosan.com/api/seo-static-link-multi-diab',
          { clinic_ids: clinicIds.map(String) },
          { headers: { 'Content-Type': 'application/json' } }
        );
        const list = data?.data?.providers || [];
        this.clinicOptions = list.map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (e) {
        console.error('Không thể tải danh sách phòng khám:', e);
        this.clinicOptions = [];
      } finally {
        this.loadingClinic = false;
      }
    },

    onClinicSelect(val) {
      const found = this.clinicOptions.find((o) => o.value === val) || null;
      this.selectedClinicObj = found;
      this.form = { ...this.form, clinicId: found ? found.value : null };
    },

    async loadBenefitTypes() {
      if (this.benefitTypeOptions.length > 0) return;
      try {
        const { data } = await this.$api.get('/BundleBenefitType/All');
        this.benefitTypeOptions = (data || []).map((item) => ({
          value: item.id,
          text: item.title || item.name || item.id,
        }));
      } catch (e) {
        console.error('Không thể tải danh sách ưu đãi:', e);
      }
      // always resolves so callers can safely .then()
    },

    onBenefitTypeSelect(val) {
      const found = this.benefitTypeOptions.find((o) => o.value === val) || null;
      this.selectedBenefitTypeObj = found;
      this.form = { ...this.form, benefitTypeId: found ? found.value : null };
    },

    onReportTypeSelect(val) {
      const found = this.reportTypeOptions.find((o) => o.value === val) || null;
      this.selectedReportTypeObj = found;
      this.form = { ...this.form, reportType: found ? found.value : null };
    },

    handleClickOutside(event) {
      if (this.$refs.providerDropdownContainer && !this.$refs.providerDropdownContainer.contains(event.target)) {
        this.showProviderDropdown = false;
      }
      if (this.$refs.tagDropdownContainer && !this.$refs.tagDropdownContainer.contains(event.target)) {
        this.showTagDropdown = false;
      }
    },

    async loadTags() {
      try {
        const { data } = await this.$api.get('/BundleTag/All');
        this.tagOptions = (data || []).map((item) => ({ value: item.id, text: item.name }));
      } catch (e) {
        console.error('Không thể tải danh sách tag:', e);
      }
    },

    onTagSearch() {
      if (!this.tagSearchText) {
        this.filteredTags = this.tagOptions;
      } else {
        this.filteredTags = this.tagOptions.filter((t) =>
          t.text.toLowerCase().includes(this.tagSearchText.toLowerCase())
        );
      }
    },

    selectTag(tag) {
      this.form = { ...this.form, bundleTagId: tag.value };
      this.tagSearchText = tag.text;
      this.showTagDropdown = false;
    },

    async createNewTag() {
      if (!this.tagSearchText || !this.tagSearchText.trim()) return;
      const tagName = this.tagSearchText.trim();
      try {
        const { data } = await this.$api.post('/BundleTag', { name: tagName });
        await this.loadTags();
        const newTag =
          (data?.id ? this.tagOptions.find((t) => String(t.value) === String(data.id)) : null) ||
          this.tagOptions.find((t) => t.text === tagName);
        if (newTag) this.selectTag(newTag);
        this.$toastr.success('Tạo tag thành công', 'Thành công');
      } catch (error) {
        this.$toastr.error('Không thể tạo tag: ' + (error.message || 'Lỗi'), 'Lỗi');
      }
    },

    onProviderSearch() {
      if (!this.providerSearchText) {
        this.filteredProviders = this.providerOptions;
      } else {
        this.filteredProviders = this.providerOptions.filter((p) =>
          p.text.toLowerCase().includes(this.providerSearchText.toLowerCase())
        );
      }
    },

    selectProvider(provider) {
      this.userEditing = true;
      this.selectedProviderObj = provider;
      this.form = { ...this.form, serviceProviderId: provider.value };
      this.providerSearchText = provider.text;
      this.showProviderDropdown = false;
      this.$nextTick(() => { this.userEditing = false; });
    },

    openAddProviderModal() {
      this.newProviderData.name = this.providerSearchText;
      this.showAddProviderModal = true;
    },

    async createNewProvider() {
      if (!this.newProviderData.name || !this.newProviderData.name.trim()) {
        this.$toastr.error('Vui lòng nhập tên nhà cung cấp', 'Lỗi');
        return;
      }
      const providerName = this.newProviderData.name.trim();
      this.isCreatingProvider = true;
      try {
        const formData = new FormData();
        formData.append('name', providerName);
        const { data } = await this.$api.post('ServiceProvider', formData);
        await this.loadProviders();
        const newProvider =
          (data?.id
            ? this.providerOptions.find((p) => String(p.value) === String(data.id))
            : null) ||
          this.providerOptions.find((p) => p.text === providerName);
        if (newProvider) {
          this.selectProvider(newProvider);
        }
        this.showAddProviderModal = false;
        this.newProviderData = { name: '' };
        this.$toastr.success('Thêm nhà cung cấp thành công', 'Thành công');
      } catch (error) {
        this.$toastr.error('Không thể thêm nhà cung cấp: ' + (error.message || 'Lỗi không xác định'), 'Lỗi');
      } finally {
        this.isCreatingProvider = false;
      }
    },

    cancelAddProvider() {
      this.showAddProviderModal = false;
      this.newProviderData = { name: '' };
      this.providerSearchText = '';
    },

    onStatusSelect(val) {
      const found = this.statusOptions.find((o) => o.value === val) || null;
      this.selectedStatusObj = found;
      this.form = { ...this.form, status: found !== null ? found.value : 0 };
    },

    onAppFeatureSelect(val) {
      const found = this.appFeatureOptions.find((o) => o.value === val) || null;
      this.selectedAppFeatureObj = found;
      this.form = { ...this.form, appFeature: found !== null ? found.value : 0 };
    },

    selected(value, field, optionsArr) {
      this.form[field] = optionsArr.find((el) => el.value === value) || null;
      const selectedVal = this.form[field];
      if (selectedVal || selectedVal?.value === 0) {
        this.$validator.reset({ name: field });
        this.$validator.errors.remove(field);
      }
      this.$nextTick(() => {
        this.$validator.validate(field);
      });
    },

    async validate() {
      return await this.$validator.validateAll();
    },

    reset() {
      this.form = {
        id: null,
        name: '',
        category: null,
        price: null,
        minutes: null,
        serviceProviderId: null,
        description: '',
        status: 0,
        appFeature: 0,
        reportType: null,
        bundleTagId: null,
        specialtyId: null,
        clinicId: null,
        benefitTypeId: null,
      };
      this.selectedStatusObj = null;
      this.selectedAppFeatureObj = null;
      this.selectedProviderObj = null;
      this.selectedReportTypeObj = null;
      this.selectedSpecialtyObj = null;
      this.selectedClinicObj = null;
      this.selectedBenefitTypeObj = null;
      this.clinicOptions = [];
      this.providerSearchText = '';
      this.tagSearchText = '';
      this.$validator.reset();
    },
  },
};
</script>

<style scoped>
.provider-dropdown {
  max-height: 320px !important;
  overflow-y: auto !important;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
}

.provider-dropdown .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 1rem;
}

.provider-dropdown .dropdown-item:hover {
  background-color: #f8f9fa;
}

.provider-dropdown .dropdown-divider {
  margin: 0.25rem 0;
}
</style>
